/* eslint-disable import/named */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { UserType } from '@microsoft-commerce/purchase-blends-component-library/dist/lib/providers/app-dependencies/user-info';
import { Constants } from '@shared/utils/constants';
import { EnvironmentType, StatusChangeSource } from '@microsoft-commerce/purchase-blends-component-library';
import { getBillingCycle, isDevelopmentEnvironment } from '@shared/utils/checkoutUtils';
import { getPBMessagesByLocale } from '@appsource/utils/purchaseHelper';
import { getPricingLocale } from '@shared/utils/pricing';
export const testTenants = [
    '03da7061-af4e-4efb-952d-513d99c72978',
    '046aa276-c9ea-4454-95a2-24f336d2f610',
    '14558494-3486-4817-a677-34cfb3dc2daa',
    '16f730f3-3e19-4af0-920c-9890872eb9b9',
    '1fdebf5f-cf48-4622-9810-f68642111c8a',
    '25c3a1c8-d497-4af6-a1e1-47c1d1c8fa4c',
    '27a469bd-4c60-46cf-b7ca-77dfe7fafcf1',
    '2be641bb-b14b-4bc7-801c-249b96dae74a',
    '3b993e36-28f5-4d5a-af4e-d9c7731086e9',
    '43565d0e-1085-4410-a5d2-f567486dd1da',
    '543fd216-0e8e-4f5e-a69c-fb0c454fd3bd',
    '60cab4b0-de18-4cb0-8d2f-d21946aa90f3',
    '65076612-2b60-41df-9e1f-65905b19995a',
    '690d692e-59bc-472b-b623-efd220455f51',
    '69bae62b-e640-4555-bd8e-5fe08cdf5bcc',
    '6ea01ee5-4652-4e6d-be21-8a5619659726',
    '7266eec8-bf7e-4648-b7d5-30c9556e0953',
    '72f988bf-86f1-41af-91ab-2d7cd011db47',
    '736ee76b-2635-4b33-a942-25ed0673f31e',
    '7584bf1d-c50b-4e38-b8d6-9cc006776e54',
    '7e02736e-e077-41ba-a913-622ad0d8ddc1',
    '84ce1578-288a-47ef-a93b-ce709fd1b117',
    '888d76fa-54b2-4ced-8ee5-aac1585adee7',
    '8af328c8-abb5-42df-94df-6ba2e08ea5ec',
    '9198735c-809f-4c71-9cb0-c35ed75131d7',
    '92dff65d-40d3-43e0-a3da-76d39e717687',
    '97491e6c-e75e-4c75-9e45-5d34a4f2d6e4',
    '975f013f-7f24-47e8-a7d3-abc4752bf346',
    'a950dcac-c2a9-48ba-8b58-768314e45377',
    'abb2da99-8c15-4b92-bb1c-df27b5a0c741',
    'b78f57bf-cd26-498e-a6fc-6b56199f7a27',
    'b98bbaa6-755d-40d4-932c-f328d3a150a3',
    'bf0954fb-e9cb-4ec2-b5c1-79c032160acf',
    'c996a3ef-75cb-4c86-859c-49d82809592a',
    'd00a08ce-f5aa-4b04-a933-52427354fe87',
    'd1ecb772-98f3-4b9e-b28a-b150dea28984',
    'd276cf8c-d731-4758-9493-877c5a9e46c6',
    'd4bbedac-4acb-4655-acfc-a603cd7b4058',
    'd725d9d1-154b-4bc2-b34d-52abd4d0df56',
    'd9e94f05-6492-4e2a-bfe1-26fbed2cf7c5',
    'e428b0dd-b737-421b-b1f0-ebaad1feef3a',
    'e4abd298-be90-4b3b-8e7a-20dc87b49af4',
    'e4f76e5e-dfc3-429c-85a3-594a3ba65706',
    'f246c7b8-fc42-4ab8-a2e2-17df716b23c1',
    'ec7e16ca-5760-4d37-b804-081f4c52d457',
    '9cf31424-222d-42dc-b8b2-067eebb758c8',
    '0c94e474-bf76-43f9-a856-060d77aa7348'
];
export const isTestUser = ({ tenantId })=>{
    return testTenants.includes(tenantId);
};
/** Determine if a user can purchase for his org / he's an IW */ export const getUserType = (roleDefinitions = [])=>{
    const canPurchaseForOrg = roleDefinitions === null || roleDefinitions === void 0 ? void 0 : roleDefinitions.some((role)=>role === Constants.RoleDefinitions.billingAdmin || role === Constants.RoleDefinitions.globalAdmin);
    return canPurchaseForOrg ? UserType.myOrg : UserType.me;
};
/**
 * Determines the PB environment to load
 * @param host the base (host) address
 */ export const getPurchaseBlendsEnv = (host)=>{
    if (host.toLowerCase().indexOf('local') !== -1 || host.toLowerCase().indexOf('internal') !== -1) {
        return {
            endpoint: EnvironmentType.int,
            log: EnvironmentType.int
        };
    }
    return {
        endpoint: EnvironmentType.prod,
        log: EnvironmentType.prod
    };
};
/** Names of components which count as Add/Edit steps in Purchase Blends */ export const AppSourceAddEditSteps = [
    StatusChangeSource.AddBillingProfile,
    StatusChangeSource.PaymentSelector,
    StatusChangeSource.BillingProfileSelector,
    StatusChangeSource.AddPayment,
    StatusChangeSource.AddProfile,
    StatusChangeSource.EditProfile,
    StatusChangeSource.EditBillingProfile
];
const AutoOpenedAddTaxIdCountryCodes = [
    'in',
    'it'
];
// Flag settings for AppSource
export const getPurchaseBlendsFlags = ({ testUser, siteEnvironment, countryCode, isQuantifiable })=>({
        EnableHideLineItemQuantityColumn: !isQuantifiable,
        EnablePaymentChallenge: true,
        EnableGetTaxIdConfig: true,
        EnableGetTaxIds: true,
        DisableBusyLoader: false,
        EnableAddTaxIdAutoOpen: AutoOpenedAddTaxIdCountryCodes.includes(countryCode.toLowerCase()),
        EnableResetStore: false,
        EnablePidlTestHeader: isDevelopmentEnvironment(siteEnvironment) || testUser,
        TempEnableClearAllMessagesWhenInit: true,
        EnableAgreementV2: true,
        ShowUpToFiveUnitPriceFractionDigits: true,
        ShowUnableToCompleteOrder: true,
        EnableAgreementSecondaryAcknowledgement: true,
        DisableModernTaxConfigOverride: false,
        EnableSequencingPidlSubmissionCalls: true
    });
export const getAppContainerProps = ({ product, planId, termId, termDuration, users, locale, bigId, skuId, quantity, recurringBilling, isBagOffer, isOneTimePayment, isProfessionalService })=>{
    var _users_profile_company, _users_profile, _users_tenantsDetails_details, _users_tenantsDetails, _users_email;
    const selectedAvailability = product === null || product === void 0 ? void 0 : product.getPlanAvailabilityByTermId(planId, termId);
    const termEntity = product === null || product === void 0 ? void 0 : product.getTermByTermId({
        planId,
        termId
    });
    const companyName = (users === null || users === void 0 ? void 0 : (_users_profile = users.profile) === null || _users_profile === void 0 ? void 0 : (_users_profile_company = _users_profile.company) === null || _users_profile_company === void 0 ? void 0 : _users_profile_company.length) ? users.profile.company || Constants.notAvailable : ((_users_tenantsDetails = users.tenantsDetails) === null || _users_tenantsDetails === void 0 ? void 0 : (_users_tenantsDetails_details = _users_tenantsDetails.details) === null || _users_tenantsDetails_details === void 0 ? void 0 : _users_tenantsDetails_details.displayName) || Constants.notAvailable;
    const email = (users === null || users === void 0 ? void 0 : (_users_email = users.email) === null || _users_email === void 0 ? void 0 : _users_email.length) ? users.email : users.alternateEmail || Constants.notAvailable;
    // TODO Yomanor: Use designed locale and messages in PB
    const purchaseBlendsComponentStrings = getPBMessagesByLocale(locale);
    var _selectedAvailability_id;
    let cartItem = {
        productId: bigId !== null && bigId !== void 0 ? bigId : '',
        skuId: skuId !== null && skuId !== void 0 ? skuId : '',
        availabilityId: (_selectedAvailability_id = selectedAvailability === null || selectedAvailability === void 0 ? void 0 : selectedAvailability.id) !== null && _selectedAvailability_id !== void 0 ? _selectedAvailability_id : '',
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        additionalData: {
            availabilityTermId: termId !== null && termId !== void 0 ? termId : '',
            billingCycle: getBillingCycle(termDuration, termEntity === null || termEntity === void 0 ? void 0 : termEntity.billingPlan),
            isThirdPartySaaSAppPurchase: true,
            isAutoRenew: isOneTimePayment || isProfessionalService ? false : recurringBilling !== null && recurringBilling !== void 0 ? recurringBilling : true
        }
    };
    if (isBagOffer) {
        cartItem = _object_spread_props(_object_spread({}, cartItem), {
            additionalData: _object_spread_props(_object_spread({}, cartItem.additionalData), {
                termDuration
            })
        });
    }
    return {
        purchaseBlendsComponentStrings,
        companyName,
        email,
        cartItem
    };
};
export const getUserData = ({ locale, market, accessToken, adminFlow })=>{
    const localeString = getPricingLocale({
        locale,
        countryCode: market
    });
    return {
        identity: undefined,
        language: locale === null || locale === void 0 ? void 0 : locale.split('-')[0],
        locale: localeString,
        market,
        token: `${Constants.Headers.Bearer} ${accessToken.commerce}`,
        type: adminFlow ? UserType.myOrg : UserType.me
    };
};
